// @tennis-matches/services/winterdoppel/planLock

import { toIsoDate } from "./dateUtils.js";

export const WINTERDOPPEL_PLAN_STRUCTURAL_FIELDS = [
  "weekdays",
  "start_time",
  "startTime",
  "end_time",
  "endTime",
  "court_count",
  "courtCount",
  "season_start",
  "seasonStart",
  "season_end",
  "seasonEnd",
];

export function isWinterDoppelPlanFinal(series) {
  return String(series?.plan_status || "draft") === "final";
}

/**
 * Erster aktiver Termin (kein Holiday, nicht cancelled).
 * @returns {string} YYYY-MM-DD oder ""
 */
export function firstWinterDoppelActiveSessionDate(sessions = []) {
  const dates = (Array.isArray(sessions) ? sessions : [])
    .filter((s) => s && !s.isHoliday && String(s.status || "") !== "cancelled")
    .map((s) => String(s.session_date || "").slice(0, 10))
    .filter((d) => /^\d{4}-\d{2}-\d{2}$/.test(d))
    .sort();
  return dates[0] || "";
}

/**
 * Veröffentlichten Plan zurücksetzen nur vor dem ersten echten Termin.
 * @returns {{ ok: boolean, reason: 'notFinal'|'seasonStarted'|'ok', firstSessionDate?: string }}
 */
export function canReopenWinterDoppelSeriesPlan({
  series,
  sessions = [],
  today = new Date(),
} = {}) {
  if (!isWinterDoppelPlanFinal(series)) {
    return { ok: false, reason: "notFinal" };
  }
  const todayYmd =
    today instanceof Date ? toIsoDate(today) : String(today || "").slice(0, 10);
  const firstSessionDate = firstWinterDoppelActiveSessionDate(sessions);
  if (firstSessionDate && todayYmd >= firstSessionDate) {
    return { ok: false, reason: "seasonStarted", firstSessionDate };
  }
  return { ok: true, reason: "ok", firstSessionDate: firstSessionDate || "" };
}

export function assertWinterDoppelPlanEditable(series, opts = {}) {
  if (isWinterDoppelPlanFinal(series) && !opts.allowPublished) {
    throw new Error("winterdoppel.plan.locked");
  }
}

export { resolveWinterDoppelSessionDisplayStatus } from "./sessionStatus.js";

export function assertWinterDoppelSessionStatusAllowed(series, status) {
  const next = String(status || "");
  if (!next || next === "proposed" || next === "cancelled") return;
  if (!isWinterDoppelPlanFinal(series)) {
    throw new Error("winterdoppel.plan.statusDraftOnly");
  }
}

export function hasWinterDoppelStructuralUpdates(updates = {}) {
  return WINTERDOPPEL_PLAN_STRUCTURAL_FIELDS.some((k) => updates[k] != null);
}
